/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Mon Apr 08 2024
 **/

import parser from "html-react-parser";
import { Column } from "@/frameworks/designStuff/components";

import * as S from "../emotion";

export default function FileName({ fileName, searchText }: { fileName: string; searchText: string }) {
	const emphasisText = `<span id='search-text'>${searchText}</span>`;
	return (
		<Column css={{ width: "100%" }}>
			<S.FileName
				maxLine={1}
				ellipsis
				align="left"
				typoSize="Title2"
				typoColor={status === "in-use" ? "neutral_00_100" : "neutral_80_100"}
			>
				{parser(fileName.replace(searchText, emphasisText))}
			</S.FileName>
		</Column>
	);
}
